import React, { useEffect, useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link, useParams } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
import FAQ from './faq'
import Latestblog from './latest-blog'
import Subscribe from '../../subscribe';
import Whatsnew from '../../whatsnew';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useGetStudyDestinationApiQuery } from '../../../core/Features/api/studyDestination/StudyDestination';
import Unlock from '../../HomePages/home-palani/section/Unlock';
import Trust from './trust';


const Australia = () => {

    const { id } = useParams();
    const { data, isLoading, isError } = useGetStudyDestinationApiQuery(id || {});
    const apiValues = data?.data || {};

    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
        });
    }, []);
    // 1️⃣ Loading state
    if (isLoading) {
        return <div className="text-center py-10">Loading...</div>;
    }

    // 2️⃣ Error or no data → Show page not exists
    if (isError || !apiValues || Object.keys(apiValues).length == 0) {
        return (
            <div className="text-center py-20">
                <h1 className="text-3xl font-bold">Page Not Found</h1>
                <p className="mt-2 text-gray-500">
                    The page you are looking for doesn’t exist.
                </p>
                <Link to="/home" className="btn btn-primary mt-4">
                    Go Back Home
                </Link>
            </div>
        );
    }


    return (
        <>
            <>
                {/* banner */}
                <section className="relative py-10 sm:py-20">
                    {/* Dynamic Background Image */}
                    <div
                        className="absolute inset-0   bg-no-repeat z-[-1]"
                        style={{
                            backgroundImage: `url(${apiValues?.bannerImageUrl})`,
                            backgroundSize: "100% 100%",
                        }}
                    />

                    {/* Optional: Dark Overlay */}
                    <div className="absolute inset-0 bg-black/60 z-[-1]" />

                    {/* Content */}
                    <div className="container relative">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="d-sm-flex align-items-center justify-content-sm-between mt-5">
                                    <div className="d-flex text-start align-items-center justify-content-sm-start justify-content-center">
                                        <div className="ms-2">
                                            <h6 className="fs-18 text-white">
                                                {apiValues?.bannerTitle}
                                            </h6>
                                            <p className="text-white fs-14">
                                                {apiValues?.bannerDescription} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* banner */}
                {/* Course detail */}

                <div className='p-3'>


                    <section className="course-details">
                        <div className="container">
                            <div className="row">

                                <div className="col-lg-8">
                                    <div className="course-page-content">
                                        <div className="card ">
                                            {/* <div className="card-body" dangerouslySetInnerHTML={{
                                                __html: apiValues?.fullPageContent?.title
                                            }} /> */}
                                            {
                                                (Array.isArray(apiValues?.newfullPageContent) ? apiValues?.newfullPageContent : []).map(
                                                    (item: any, index: number) => (
                                                        <>

                                                            <div
                                                                key={index}
                                                                className="card-body"
                                                                dangerouslySetInnerHTML={{ __html: item?.title }}
                                                            />
                                                          {
                                                             item?.thumbnailUrl &&
                                                            <Trust videoUrl={item?.videoUrl} thumbnailUrl={item?.thumbnailUrl} />
                                                          }
                                                          {
                                                            item?.buttonText && 

                                                            <Link
                                                                to={route.Unlock}
                                                                className="mb-2"
                                                            >
                                                                <button className="ml-4 p-3 px-4 rounded-full text-white bg-[#1D1753]">

                                                                    {item?.buttonText}
                                                                </button>
                                                            </Link>

                                                          
                                                          }

                                                        </>

                                                    )
                                                )
                                            }


                                        </div>

                                    </div>
                                </div>

                                <div className="col-lg-4">
                                    <div className="course-page-content">

                                        <div className="card">
                                            <div className="card-body">

                                                <div className=''>
                                                    <h5 className="subs-title mb-3">
                                                        {apiValues?.rightSideTitle}
                                                    </h5>
                                                    <p className="mb-3">
                                                        {apiValues?.rightSideDescription}
                                                    </p>
                                                </div>
                                                <Link
                                                    to={route.Unlock}
                                                    className="btn btn-primary w-100 mt-4 btn-enroll"
                                                >
                                                    {apiValues?.rightSideButtonText}
                                                </Link>
                                            </div>

                                        </div>


                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="subs-title">
                                                    {apiValues?.rightSideIncludesText}
                                                </h5>


                                                {
                                                    (Array.isArray(apiValues?.rightSideIncludes) ? apiValues?.rightSideIncludes : []).map((item: any, index: number) => {

                                                        return (
                                                            <p className="flex items-center gap-1">
                                                                <ImageWithBasePath
                                                                    className="me-2 h-8 w-8"
                                                                    source={item?.icon}
                                                                    alt="img"
                                                                />
                                                                {item?.title}
                                                            </p>
                                                        )
                                                    }) || []
                                                }



                                            </div>
                                        </div>

                                        <div className="cou-features-card card">
                                            <div className="cou-features card-body">
                                                <h5 className="subs-title mb-4">
                                                    {apiValues?.rightSidecourseFeaturesText}
                                                </h5>

                                                {
                                                    (Array.isArray(apiValues?.courseFeatures) ? apiValues?.courseFeatures : []).map((item: any, index: number) => {

                                                        return (

                                                            <p className="flex items-center gap-1">
                                                                <ImageWithBasePath
                                                                    className="me-2 h-8 w-8"
                                                                    source={item?.icon}
                                                                    alt="img"
                                                                />
                                                                {item?.title}
                                                            </p>


                                                        )
                                                    }) || []
                                                }



                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                    <FAQ apiValues={apiValues} />
                    {/* <Latestblog /> */}
                    <Subscribe apiValues={apiValues} />
                    <Whatsnew apiValues2={apiValues?.parentId} extraData={apiValues} />
                    <Unlock />

                </div>

            </>

        </>
    )
}

export default Australia
